module.exports = __webpack_public_path__ + "946a9a04206536bd4b68caf3d0e3526f.svg";